var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarBlackMiddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 100,
    viewBox: "0 0 75 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1451 99.6778C30.2595 99.6778 23.0339 94.8574 23.0339 88.9296V66H55.3538V88.9296C55.3538 94.8574 48.0306 99.6778 39.1451 99.6778Z",
    fill: "#90554B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.438 75.1849C49.1046 75.1849 55.1585 66.5211 55.1585 66.5211C55.1585 66.5211 57.7949 79.4842 42.0743 80.331C31.9195 80.8521 23.0339 69.8433 23.0339 69.8433C23.0339 69.8433 28.6972 75.1849 39.438 75.1849Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3413 39.4351C64.3413 39.4351 66.9627 35.332 72.2056 37.3836C77.4484 39.3211 75.0549 52.0863 67.1907 53.7959C67.1907 53.7959 64.3413 54.3658 62.1758 52.4282C62.1758 52.4282 64.1133 42.9683 64.3413 39.4351Z",
    fill: "#90554B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1766 41.8279C71.1766 41.8279 66.7316 40.3462 63.6543 46.8428",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7026 43.651C65.7026 43.651 70.4896 46.2724 67.4123 50.1475",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8241 52.4283C10.5446 54.3659 7.80926 53.796 7.80926 53.796C-0.0549876 52.0864 -2.44847 39.3213 2.79437 37.3837C8.0372 35.3322 10.5446 39.4352 10.5446 39.4352C10.8866 42.9684 12.8241 52.4283 12.8241 52.4283Z",
    fill: "#90554B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81738 41.8287C3.81738 41.8287 8.26238 40.347 11.3397 46.8436",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17653 43.6523C9.17653 43.6523 4.3896 46.2737 7.58089 50.1489",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9075 27.3539C64.9075 34.9902 64.1097 51.0606 59.4367 60.6345C54.9917 69.6385 47.5833 74.4254 38.0095 74.7674C28.3216 74.9953 21.1412 71.3481 15.4425 59.7227C9.74376 47.9833 9.97171 27.4679 9.97171 27.4679C9.97171 27.4679 9.97171 0 37.0977 0C65.7053 0 64.9075 27.3539 64.9075 27.3539Z",
    fill: "#90554B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1812 48.4393L38.1297 49.0092C37.1039 49.2371 36.0782 48.7812 35.6223 47.8694C35.5463 47.6415 35.5083 47.3755 35.5083 47.0716V34.8763",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5297 35.7881C27.5297 37.2698 26.39 38.4095 24.9083 38.4095C23.5406 38.4095 22.4009 37.2698 22.4009 35.7881C22.4009 34.4204 23.5406 33.2807 24.9083 33.2807C26.39 33.2807 27.5297 34.4204 27.5297 35.7881Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.387 33.2807C49.7547 33.2807 50.8945 34.4204 50.8945 35.7881C50.8945 37.2698 49.7547 38.4095 48.387 38.4095C46.9054 38.4095 45.7656 37.2698 45.7656 35.7881C45.7656 34.4204 46.9054 33.2807 48.387 33.2807Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8071 56.8734H43.826",
    stroke: "#431818",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.457 61.0903C33.457 61.0903 36.4204 62.116 40.1815 61.0903",
    stroke: "#431818",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41C21 41 23.9633 42.0258 27.7245 41",
    stroke: "#431818",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46 41C46 41 48.9633 42.0258 52.7245 41",
    stroke: "#431818",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21C49 21 38.8644 18.75 26 21",
    stroke: "#431818",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51 90C51 90 40.8644 92.25 28 90",
    stroke: "#431818",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBlackMiddle);
export default __webpack_public_path__ + "static/media/avatar-black-middle.77348e8fefc56f445e762b7f097e1840.svg";
export { ForwardRef as ReactComponent };